/*
 * Copyright (c) 2022-2024. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import dayjs from 'dayjs'
import { getInOutLog } from '@/model/dataLayer/api/storage/inventory'

const entity = {
  operation: {},
  name: {
    displayName: 'resourceName'
  },
  createdAt: {
    displayName: 'TimeStamp',
    type: IKDataEntity.Types.Date
  },
  unitDisplay: {},
  priceLiteral: {
    displayName: 'InventoryChange',
    type: IKDataEntity.Types.Float
  },
  soldByCashier: {},
  note: {}

}

const config = {
  load: async function (filter) {
    const [dateTimeFrom, dateTimeTo] = getZBonTimeLimit(...filter[0].dateFilter)
    const arr = await getInOutLog(dateTimeFrom, dateTimeTo)
    return arr.map(it => {
      console.log(it)
      return {
        ...it.changeLog,
        name: it.dishResource.dishResource.name,
        ...it,
        priceLiteral: it.changeLog.priceLiteral * it.changeLog.amount,
        soldByCashier: it.changeLog.soldByCashier ? '是' : 'No'
      }
    })
  }
}

function getZBonTimeLimit (start, end) {
  const dStart = dayjs(start).startOf('d').add(3, 'hour').add(59, 'minute').toISOString()
  const dEnd = dayjs(end).endOf('d').add(3, 'hour').add(59, 'minute').toISOString()
  return [dStart, dEnd]
}

export default IKDataEntity.ModelFactory(entity, config)
